import { dataExportStore } from 'App/data-export/store/dataExportStore'
import { MultiSelect } from 'components/MultiSelect/MultiSelect'
import { translate } from 'i18n/i18n'
import { sortByKey } from 'utils/sortByKey'

export const IrrigationZoneEmittersSelect = ({
  options,
}: {
  options: Array<{ value: string; label: string }>
}) => {
  const state = dataExportStore.useSelector((s) => s)

  return (
    <div>
      <div css={{ fontSize: 17 }}>{translate.phrases.banyanApp('Irrigation Zones')}</div>
      <div css={{ marginTop: 10, marginBottom: 10 }}>
        <MultiSelect
          selectedData={state.formState.irrigationZoneEmitterIds
            .map((id) => ({
              value: id,
              label: options.find((x) => x.value === id)?.label,
              id: id,
            }))
            .sort(sortByKey('label'))}
          onChange={(data) =>
            dataExportStore.actions.changeIrrigationZoneEmitterIds(data.map((x) => String(x.value)))
          }
          data={options}
        />
      </div>
    </div>
  )
}
